export default "__VITE_ASSET__Df$xu69F__"